
(function () {
  'use strict';
  if (window.DaLucaHardCenterV374) return;
  window.DaLucaHardCenterV374 = true;

  function px(n) { return Math.round(n) + 'px'; }

  function hardCenter(el, maxWidth, sidePad) {
    if (!el) return;

    var vw = document.documentElement.clientWidth || window.innerWidth || 0;
    if (!vw) return;

    var pad = typeof sidePad === 'number' ? sidePad : 24;
    var width = Math.min(maxWidth, Math.max(280, vw - (pad * 2)));

    // Reset any old centering scheme first so each run is deterministic.
    el.style.setProperty('box-sizing','border-box','important');
    el.style.setProperty('position','relative','important');
    el.style.setProperty('transform','none','important');
    el.style.setProperty('margin-left','0','important');
    el.style.setProperty('margin-right','0','important');
    el.style.setProperty('left','0px','important');
    el.style.setProperty('width',px(width),'important');
    el.style.setProperty('max-width',px(width),'important');

    var rect = el.getBoundingClientRect();
    var desiredLeft = Math.max(pad, (vw - rect.width) / 2);
    var delta = desiredLeft - rect.left;

    el.style.setProperty('left',px(delta),'important');
  }

  function centerReadyMilitaryEditorial() {
    var wrapper = document.querySelector('.daluca-product-details--ready-military .daluca-ready-military-editorial-v371');
    if (!wrapper) return;

    // Center the entire editorial relative to the viewport, not its legacy
    // Shopify row/column ancestor.
    hardCenter(wrapper, 1180, 24);

    var features = wrapper.querySelector('.daluca-ready-military-editorial-v371__features');
    if (features) {
      features.style.setProperty('width','880px','important');
      features.style.setProperty('max-width','calc(100vw - 48px)','important');
      features.style.setProperty('margin-left','auto','important');
      features.style.setProperty('margin-right','auto','important');
    }

    var featureGrid = wrapper.querySelector('.daluca-ready-military-feature-grid-v371');
    if (featureGrid) {
      featureGrid.style.setProperty('width','100%','important');
      featureGrid.style.setProperty('max-width','880px','important');
      featureGrid.style.setProperty('margin-left','auto','important');
      featureGrid.style.setProperty('margin-right','auto','important');
      featureGrid.style.setProperty('justify-content','center','important');
      featureGrid.style.setProperty('justify-items','center','important');
    }

    var materials = wrapper.querySelector('.daluca-ready-military-editorial-v371__materials');
    if (materials) {
      materials.style.setProperty('width','1100px','important');
      materials.style.setProperty('max-width','calc(100vw - 48px)','important');
      materials.style.setProperty('margin-left','auto','important');
      materials.style.setProperty('margin-right','auto','important');
    }

    var materialGrid = wrapper.querySelector('.daluca-ready-military-material-grid-v371');
    if (materialGrid) {
      materialGrid.style.setProperty('width','100%','important');
      materialGrid.style.setProperty('max-width','1100px','important');
      materialGrid.style.setProperty('margin-left','auto','important');
      materialGrid.style.setProperty('margin-right','auto','important');
      materialGrid.style.setProperty('justify-content','center','important');
    }
  }

  function run() {
    centerReadyMilitaryEditorial();
  }

  var timer = 0;
  function queue() {
    clearTimeout(timer);
    timer = setTimeout(run, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once:true });
  } else {
    run();
  }

  window.addEventListener('resize', queue, { passive:true });

  if (document.body) {
    new MutationObserver(queue).observe(document.body,{childList:true,subtree:true});
  }

  // Recheck after async theme/app/product-detail rendering settles.
  [100,250,500,900,1500,2500,4000].forEach(function(ms){
    setTimeout(run,ms);
  });
})();
